import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grow-0 flex flex-row gap-2 px-2 py-1 items-center justify-start rounded-lg" }
const _hoisted_2 = {
  key: 0,
  class: "flex-initial h-full flex items-center"
}
const _hoisted_3 = { class: "flex-1 self-strech min-h-0 max-h-full grow relative flex justify-center items-stretch" }
const _hoisted_4 = { class: "absolute inset-y-0 space-y-1 right-0 flex items-center pr-2" }
const _hoisted_5 = { class: "flex-initial flex items-center space-x-2" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "animate-ping top-0 -right-0 absolute inline-flex h-1.5 w-1.5 rounded-full bg-primary opacity-50" }, null, -1)

import { ref, computed } from 'vue';
import { FileVideo, Image, LoaderCircle, Mic, Send, Smile } from 'lucide-vue-next';
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';
import { useStore } from 'vuex';
import { SEND_MESSAGE, SendMessageStorePayload } from '@/store';
import Button from '@/components/ui/button/Button.vue';
import { ConversationTarget, Message, ImageUpload, SendMessageType } from '@/http/customerSession';
import ImagePopover from '@/components/ImagePopover.vue';
import Textarea from '@/components/ui/textarea/Textarea.vue';
import { get, set } from '@vueuse/core';

const HAS_EMOJI_FEATURE = false;
const HAS_MIC_FEATURE = false;
const HAS_AUTOMATIC_MESSAGES = false;


export default /*#__PURE__*/_defineComponent({
  __name: 'KeyboardComponent',
  props: {
    disabled: {
        type: Boolean,
        default: false,
        required: false
    },
    sessionId: {
        type: String,
        required: true
    },
    customerKey: {
        type: String,
        required: true
    }
},
  emits: ['update-read', 'scroll-to-the-end'],
  setup(__props, { emit: __emit }) {

const selectedValue = ref('CHAT');

const props = __props;

const emit = __emit;

const keyboardMessage = ref();
const { dispatch } = useStore();
const isSending = ref(false);
const messageType = ref<SendMessageType>('text');

const image = ref<ImageUpload | undefined>();
const imgSrc = computed<string | undefined>(() => {
    const selectedImage = get(image);
    if (selectedImage === undefined) {
        return undefined;
    }
    return selectedImage?.imageSourceChoice === 'URL'
        ? selectedImage?.imageContent
        : `data:${selectedImage?.imageContentType};charset=utf-8;base64, ${selectedImage?.imageContent}`;
});

const showError = ref(false);

const sendTextMessage = async (event: KeyboardEvent) => {
    if (event.key !== "Enter" && event.key !== undefined) {
        return;
    }
    if (get(isSending) === false && props.disabled === false) {
        const imageToUpload: ImageUpload | undefined = get(image);
        if (imageToUpload !== undefined) {
            set(messageType, 'image');
        }
        let payload: SendMessageStorePayload = {
            sessionId: props.sessionId,
            request: {
                target: selectedValue.value as ConversationTarget,
                type: get(messageType),
                message: {
                    text: (keyboardMessage.value ?? "").trim() !== "" ? keyboardMessage.value : undefined,
                    imageContent: imageToUpload?.imageContent,
                    imageContentType: imageToUpload?.imageContentType,
                    imageSourceChoice: imageToUpload?.imageSourceChoice
                } as Message,
            }
        };
        if (Object.entries(payload.request.message).length === 0) {
            return;
        }
        try {
            set(isSending, true);
            await dispatch(SEND_MESSAGE, payload);
            set(image, undefined);
            set(messageType, 'text');
            emit("update-read", keyboardMessage.value);
            emit("scroll-to-the-end");
            keyboardMessage.value = undefined;
        } catch (err) {
            set(showError, true);
            setTimeout(() => set(showError, false), 2000);
        } finally {
            set(isSending, false);
        }
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    HAS_AUTOMATIC_MESSAGES
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(FileVideo))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Textarea, {
        type: "text",
        placeholder: "Escreva mensagem",
        name: "message",
        class: _normalizeClass(["readonly:bg-gray-100 bg-white min-h-0 max-lg:py-4 max-lg:pr-[36px] lg:pr-[90px] box-border border disabled:bg-gray-100 border-gray-300 rounded-l-2xl text-sm font-semibold resize-none focus-visible:ring-offset-0 focus-visible:ring-1", {
                    'cursor-not-allowed': isSending.value
                }]),
        disabled: props.disabled,
        readonly: isSending.value,
        modelValue: keyboardMessage.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyboardMessage).value = $event)),
        onKeypress: sendTextMessage
      }, null, 8, ["disabled", "readonly", "class", "modelValue"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Select), {
          name: "chatSelected",
          modelValue: selectedValue.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedValue).value = $event)),
          "default-value": 'CHAT',
          disabled: props.disabled
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SelectTrigger), {
              class: _normalizeClass([selectedValue.value === 'INTERNAL' ? 'bg-blue-200 text-primary' : 'bg-gray-100', "w-[90px] max-lg:h-[36px] lg:h-[24px] xl:h-[36px]"])
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectValue))
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_unref(SelectContent), null, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectGroup), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SelectItem), { value: "CHAT" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cliente")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(SelectItem), { value: "INTERNAL" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Oculto")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      HAS_EMOJI_FEATURE
        ? (_openBlock(), _createBlock(_unref(Smile), { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ImagePopover, {
        modelValue: image.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((image).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(Button, {
            variant: "ghost",
            size: "icon",
            disabled: props.disabled || isSending.value,
            class: _normalizeClass({
                        'relative': true,
                        'bg-accent': imgSrc.value !== undefined
                    })
          }, {
            default: _withCtx(() => [
              (imgSrc.value === undefined)
                ? (_openBlock(), _createBlock(_unref(Image), {
                    key: 0,
                    class: "text-primary opacity-75"
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createElementVNode("img", {
                      class: "object-scale-down h-full w-full",
                      src: imgSrc.value
                    }, null, 8, _hoisted_7),
                    _hoisted_8
                  ]))
            ]),
            _: 1
          }, 8, ["disabled", "class"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      HAS_MIC_FEATURE
        ? (_openBlock(), _createBlock(_unref(Mic), { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(Button, {
        class: _normalizeClass(["h-auto w-auto max-lg:p-3 lg:p-1 disabled:opacity-80 bg-blue-700 text-white rounded-md flex items-center justify-center disabled:cursor-not-allowed", { 'bg-destructive': showError.value }]),
        variant: "default",
        onClick: sendTextMessage,
        disabled: props.disabled || isSending.value
      }, {
        default: _withCtx(() => [
          (isSending.value)
            ? (_openBlock(), _createBlock(_unref(LoaderCircle), {
                key: 0,
                class: "animate-spin"
              }))
            : (_openBlock(), _createBlock(_unref(Send), { key: 1 }))
        ]),
        _: 1
      }, 8, ["class", "disabled"])
    ])
  ]))
}
}

})